import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Card, Button, Spinner, Alert } from 'react-bootstrap';
import api from '../api/axios';
import { completeExam, clearExam } from '../store/examSlice';

const ExamResults = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { sessionId, questions, answers } = useSelector((state) => state.exam);
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const finishExam = async () => {
      try {
        const res = await api.post('/exam.php?action=complete', { sessionId });
        dispatch(completeExam({ score: res.data.score, results: res.data.results }));
        setResults(res.data);
      } catch (err) {
        console.error(err);
        alert('Failed to complete exam');
      } finally {
        setLoading(false);
      }
    };
    finishExam();
  }, [sessionId, dispatch]);

  if (loading) return <Container className="mt-5 text-center"><Spinner animation="border" /></Container>;
  if (!results) return <Container className="mt-5"><Alert variant="warning">No results</Alert></Container>;

  return (
    <Container className="mt-5 text-center">
      <Card className="shadow-sm p-4">
        <h2>Exam Results</h2>
        <p className="lead">Your score: {results.score} out of {results.totalQuestions}</p>
        <div className="d-flex justify-content-center gap-2">
          <Button variant="primary" onClick={() => navigate('/exam/review')}>
            Review Answers
          </Button>
          <Button variant="outline-primary" onClick={() => { dispatch(clearExam()); navigate('/dashboard'); }}>
            Back to Dashboard
          </Button>
        </div>
      </Card>
    </Container>
  );
};

export default ExamResults;